<script>
	import Modal from './Modal.svelte';
	import { createEventDispatcher } from 'svelte';

	export let className = undefined;
	export let title = '';
	export let message = '';
	export let confirm = 'Confirm';
	export let onConfirm;
	export let open = false;
	export let showCancel = true;
	export let cancelText = 'Cancel';

	const dispatch = createEventDispatcher();

	const close = () => {
		open = false;
		dispatch('close');
	};

	function confirmClicked() {
		open = false;
		onConfirm();
	}
</script>

{#if open}
	<Modal on:close={close} {className} prompt={true}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">{title}</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			{#if message}
				<p class="mb-6">{message}</p>
			{/if}
			<slot />
			{#if onConfirm}
				<button class="mb-4 btn btn-primary" on:click={confirmClicked}>
					{confirm}
				</button>
			{/if}
			{#if showCancel}
				<button class="mb-4 btn btn-muted" on:click={close}>
					{cancelText}
				</button>
			{/if}
		</div>
	</Modal>
{/if}
